module.exports = __webpack_public_path__ + "media/images/registrations/testimonial_version/bg-02-90f27ff4c36cc87d0df2847c711f4057.png";